var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 3.75C1.25 3.08696 1.51339 2.45107 1.98223 1.98223C2.45107 1.51339 3.08696 1.25 3.75 1.25H4.89333C5.61 1.25 6.235 1.73833 6.40917 2.43333L7.33 6.11917C7.40462 6.4175 7.38955 6.73122 7.28667 7.02102C7.18379 7.31082 6.99769 7.56383 6.75167 7.74833L5.67417 8.55667C5.56167 8.64083 5.5375 8.76417 5.56917 8.85C6.03948 10.129 6.78216 11.2906 7.74579 12.2542C8.70941 13.2178 9.87096 13.9605 11.15 14.4308C11.2358 14.4625 11.3583 14.4383 11.4433 14.3258L12.2517 13.2483C12.4362 13.0023 12.6892 12.8162 12.979 12.7133C13.2688 12.6105 13.5825 12.5954 13.8808 12.67L17.5667 13.5908C18.2617 13.765 18.75 14.39 18.75 15.1075V16.25C18.75 16.913 18.4866 17.5489 18.0178 18.0178C17.5489 18.4866 16.913 18.75 16.25 18.75H14.375C7.12667 18.75 1.25 12.8733 1.25 5.625V3.75Z",
    fill: "url(#paint0_linear_136_4136)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_136_4136",
    x1: 10,
    y1: -7.21774,
    x2: 10,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78520"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7e558b65f4e752d0202846c515dc86b2.svg";
export { ForwardRef as ReactComponent };